import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useI18n } from '../../../../context/occ/hooks/use-i18n';
import { useFieldValidator } from '../../../../hooks/use-field-validator';
import { Fieldset } from '../../fieldset/fieldset';
import { getFormFieldErrorMessage } from '../../form-field-utils';
import { RadioGroup } from '../../input/radio-group/radio-group';
import { getFieldProps } from '../utils/get-field-props';
const b = bemClassBuilder('v-radio-group-field');
export const RadioGroupField = observer(props => {
    const i18n = useI18n();
    const { displayText, error, validate, onChangeValue, setHelpText } = props;
    const errorMessage = getFormFieldErrorMessage(error, displayText, i18n);
    const { onValueChangedValidation } = useFieldValidator(validate, setHelpText, errorMessage);
    const handleChangeEvent = (event) => {
        const newValue = event.currentTarget.value;
        onChangeValue(newValue);
        onValueChangedValidation(newValue, !!errorMessage);
    };
    const fieldProps = getFieldProps(Object.assign(Object.assign({}, props), { b, helpText: errorMessage }));
    return (_jsx(Fieldset, Object.assign({}, fieldProps, { children: _jsx(RadioGroup, Object.assign({}, props, { className: undefined, onChange: handleChangeEvent })) })));
});
RadioGroupField.displayName = 'RadioGroupField';
